// Live (on-site) engraving investment, package, capacity and insurance. Owner
// 2026-11-03 (.seo/truth.md "Agency and event pages"): publish an idea of
// investment, not a price ladder that anchors low; no per-item unit prices.
// One source for the on-site engraving page, the live beauty page and the
// personalization bar.
const eventPricing = {
  investment: '$5,000–$10,000+',
  investmentNote:
    'Most brand activations, depending on guest count, hours, stations and items.',
  answer:
    'Most brand activations run $5,000–$10,000+, depending on guest count, hours, number of stations and whether we supply the items. Smaller private and office events are quoted separately. Multi-day trade shows are quoted per day.',
  rows: [
    { label: 'Standard activation', value: '1 station, 2 staff' },
    { label: 'Live engraving', value: 'Up to 3 hours' },
    {
      label: 'Included',
      value: 'Sample testing on your item, setup and breakdown',
    },
    {
      label: 'Add more',
      value: 'Extra hours; a second station for 300+ guests',
    },
    { label: 'Items we supply', value: 'From about $10–$30 per guest' },
    { label: 'Multi-day trade shows', value: 'Quoted per day' },
  ],
  notes: [
    'Smaller private and office events are quoted separately. A 50% deposit reserves the date; the balance is due before the event. Taxes are not included.',
  ],
  items: 'From about $10–$30 per guest, depending on the item',
}

const eventCapacity = {
  perHour: '40–50',
  batch: 'about 250',
  summary:
    'One station engraves about 40–50 items an hour. With batch loading, where guests submit names by QR code and pick up later, one station can finish about 250 items in 3 hours.',
}

const eventPackage =
  'A standard activation is 1 station and 2 staff for up to 3 hours of live engraving, plus sample testing on your item, setup and breakdown. Extra hours and a second station (for 300+ guests) are available.'

const eventPriceAnswer = `${eventPricing.answer} ${eventPackage} A 50% deposit reserves the date, and taxes are not included.`

const eventInsurance = {
  question: 'Do you provide a certificate of insurance (COI)?',
  answer:
    'Yes. We carry general liability insurance and can provide a certificate of insurance (COI) naming your agency or venue. Send the venue’s requirements with your brief.',
}

module.exports = {
  eventPricing,
  eventCapacity,
  eventPackage,
  eventPriceAnswer,
  eventInsurance,
}
